module.exports = __webpack_public_path__ + "media/assets/images/snow_sometime_will_cloudy-aeebeb5f7ac73a07f7e161c91926a3f2.png";